import { ReactElement } from "react";

// Base PDF configuration interface
export interface PDFConfig {
  title?: string;
  fileName: string;
  pageSize?: "A4" | "LETTER";
  orientation?: "portrait" | "landscape";
}

// PDF generation context
export interface PDFContext {
  config: PDFConfig;
  data: any;
  cmsData?: {
    pathwayCms?: any;
    hatCms?: any;
    coreTypesCms?: any;
    workValuesCms?: any;
    educationCms?: any;
    buildingBlocksCms?: any;
    buildingBlockActivitiesCms?: any;
  };
  metadata?: {
    generatedAt: Date;
    generatedBy?: string;
    version?: string;
  };
  activityIconConverted?: string;
}

// PDF component props interface
export interface PDFComponentProps {
  data: any;
  config?: Partial<PDFConfig>;
  metadata?: PDFContext["metadata"];
}

// PDF factory interface
export interface PDFFactory {
  createPDF: (context: PDFContext) => ReactElement;
  getConfig: () => PDFConfig;
  validateData: (data: any) => boolean;
}

// PDF types enum for type safety
export enum PDFType {
  CAREER_PLAN = "career_plan",
  COURSE_PLAN = "course_plan",
  CLIMB_PLAN = "climb_plan",
  CERTIFICATE = "certificate",
  REPORT = "report",
  TRANSCRIPT = "transcript",
}

// PDF registry for managing different PDF types
export interface PDFRegistry {
  [PDFType.CAREER_PLAN]: PDFFactory;
  [PDFType.COURSE_PLAN]: PDFFactory;
  [PDFType.CLIMB_PLAN]: PDFFactory;
  [PDFType.CERTIFICATE]: PDFFactory;
  [PDFType.REPORT]: PDFFactory;
  [PDFType.TRANSCRIPT]: PDFFactory;
}
